<template>
    <div v-if="alerts && alerts.employee">
        <div v-if="this.type !== 'dashboards'" class="container">
            <alert :alert="alert" :type="type" :key="alert.id" v-for="alert in alerts.employee" />
        </div>
        <template v-else>
            <alert :alert="alert" :type="type" :key="alert.id" v-for="alert in alerts.employee" />
        </template>
    </div>
</template>

<script>
    import ErrorsZone from "./ErrorsZone";
    import {useGetLoader} from "./compositions/axios/loadingRequest";

    export default {
        name: 'Alerts',

        components: {
            ErrorsZone,
        },

        props: {
            alertsAction: {
                type: String,
                required: false,
            },
            type: {
                type: String,
                required: false,
            },
        },

        setup() {
            const {
                loaded,
                loading,
                errors,
                load,
            } = useGetLoader();

            return {
                loaded,
                loading,
                errors,
                load,
            };
        },

        data() {
            return {
                alerts: {},
            };
        },

        created() {
            if(this.type === 'dashboards') {
                Echo.channel(`dashboards`).listen('AlertUpdatedEvent', (e) => {
                    this.loadStateFromServer();
                });
            } else {
                Echo.private(`employees`).listen('AlertUpdatedEvent', (e) => {
                    this.loadStateFromServer();
                });
            }
        },

        async mounted() {
            await this.loadStateFromServer();
        },

        methods: {
            loadStateFromServer: async function () {
                let alertsAction;
                if(this.type === 'dashboards') {
                    alertsAction = '/dashboards/alertes';
                } else {
                    alertsAction = this.alertsAction;
                }
                if(alertsAction) {
                    this.alerts = await this.load(alertsAction);
                }
            },
        },
    }
</script>

<style scoped lang="scss">
</style>
